<section class="accordion-block">
  <h3>Installations</h3>
  @for (groupe of groupes(); track groupe.tag) {
    <button
      class="accordion-item"
      [class.accordion-item-open]="groupe.ouvert()"
      (click)="groupe.ouvert.set(!groupe.ouvert())"
    >
      {{ groupe.tag }}
      <span class="accordion-count">{{ groupe.installations.length }}</span>
    </button>
    @if (groupe.ouvert()) {
      <div class="accordion-installations">
        @for (installation of groupe.installations; track installation.id) {
          <a [routerLink]="['/installation', installation.id]" class="installation-line">
            {{ installation.nom }}
          </a>
        }
      </div>
    }
  }
</section>
